var map = {
	"./btc.png": "2574",
	"./eth.png": "87c6",
	"./eur.png": "9061",
	"./gbp.png": "d569",
	"./usd.png": "9b01",
	"./usdc.png": "d907",
	"./usdt.png": "8e81"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9bb";